module.exports = __webpack_public_path__ + "static/dropa-a3b8d6d4ce653094a2fb348a58522f6a.png";